import type { RouteInformation } from "@/components/navigation/Navigation"
import { SystemRole } from "@/models"
import { faMap, faPlusCircle, faTableList } from "@fortawesome/free-solid-svg-icons"

export const AppRoutes: Record<string, RouteInformation> = {
	"/incident-map": {
		name: "Incident Map",
		icon: faMap,
		hasAccess: (user) => user.atLeastHasRole(SystemRole.CoastguardReadOnly),
	},
	"/incidents/list": {
		name: "All Incident Logs",
		icon: faTableList,
		hasAccess: (user) => user.atLeastHasRole(SystemRole.CoastguardReadOnly),
	},
	"/incidents/create": {
		name: "Create Incident",
		icon: faPlusCircle,
		hasAccess: (user) => user.atLeastHasRole(SystemRole.CoastguardOfficer),
	},
	"/vts-logs/list": {
		name: "VTS Logs",
		icon: faTableList,
		divider: true,
	},
}
